<template>
<v-container fill-height fluid>
	<v-row 
		align="center"
		justify="center">
		
    <h2>Under Development.</h2>
	</v-row>

</v-container>
</template>

<script>
export default {
  name: 'Questions'
}
</script>